"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.MEDIA_DESKTOP_XL_MIN = exports.MEDIA_DESKTOP_MIN = exports.MEDIA_MOBILE_MAX = exports.MEDIA_MOBILE_MIN = exports.MEDIA_MOBILE_SM_MAX = void 0;
const MEDIA_MOBILE_SM_MAX = 575;
exports.MEDIA_MOBILE_SM_MAX = MEDIA_MOBILE_SM_MAX;
const MEDIA_MOBILE_MIN = 576;
exports.MEDIA_MOBILE_MIN = MEDIA_MOBILE_MIN;
const MEDIA_MOBILE_MAX = 991;
exports.MEDIA_MOBILE_MAX = MEDIA_MOBILE_MAX;
const MEDIA_DESKTOP_MIN = 992;
exports.MEDIA_DESKTOP_MIN = MEDIA_DESKTOP_MIN;
const MEDIA_DESKTOP_XL_MIN = 1200;
exports.MEDIA_DESKTOP_XL_MIN = MEDIA_DESKTOP_XL_MIN;
